import { useField, useFormikContext } from "formik";
import { i18n } from "next-i18next";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { isExists } from "../../utils";

const AddressSelectInput = (props) => {
  const {
    isMulti,
    label,
    name,
    className,
    optionValue,
    secondField,
    optionName,
    placeholder,
    endpoint,
    param,
    skip,
    disabled,
    token,
  } = props;
  const [options, setOptions] = useState([]);
  const [field, meta] = useField(name);
  useEffect(() => {
    if (!skip) getData();
  }, [skip, field.value]);

  const getData = () => {
    let url = `${process.env.FIXITYURL}/${endpoint}`;
    if (!skip && param && param.id && param.value) {
      url = `${url}?${param.id}=${param.value}`;
    }
    fetch(url, {
      headers: { Authorization: "Bearer " + token },
    }).then(async (response) => {
      const data = response.ok ? await response.json() : null;
      setOptions(data?.data || []);
    });
  };
  const { setFieldValue } = useFormikContext();

  const handleChange = (option) => {
    const selectedId = optionValue
      ? `${option[optionValue]}`
      : `${option["id"]}`;
    if (selectedId && selectedId !== "") clearChildField(name, setFieldValue);
    setFieldValue(name, selectedId);
    if (secondField && Object.keys(secondField).length > 1) {
      setFieldValue(secondField.name, option[secondField.value], false);
    }
  };

  const locale = (options, prefix = "") => {
    let formattedOptions = [];

    options.forEach((option) => {
      let obj = {
        [optionValue]: optionValue
          ? `${option[optionValue]}`
          : `${option["id"]}`,
        label: i18n.t(`${prefix ?? ""}${option.name}`),
      };
      formattedOptions.push(obj);
    });

    return formattedOptions;
  };

  function clearableFields(name) {
    const clearFields = [
      "cityId",
      "townId",
      "townShipId",
      "villageId",
      "districtId",
      "streetId",
      "buildingId",
      "doorId",
    ];

    const locationIndex = clearFields.indexOf(name);
    let fields = [...clearFields];
    const filteredFields = fields.splice(locationIndex + 1, fields.length);

    return filteredFields;
  }
  const clearChildField = (name, setFieldValue) => {
    if (name === "cityId") {
      const clearFields = clearableFields("cityId");
      clearFields.map((item) => setFieldValue(item, null, false));
    } else if (name === "townId") {
      const clearFields = clearableFields("townId");
      clearFields.map((item) => setFieldValue(item, null, false));
    } else if (name === "townShipId") {
      const clearFields = clearableFields("townShipId");
      clearFields.map((item) => setFieldValue(item, null, false));
    } else if (name === "villageId") {
      const clearFields = clearableFields("villageId");
      clearFields.map((item) => setFieldValue(item, null, false));
    } else if (name === "districtId") {
      const clearFields = clearableFields("districtId");
      clearFields.map((item) => setFieldValue(item, null, false));
    } else if (name === "streetId") {
      const clearFields = clearableFields("streetId");
      clearFields.map((item) => setFieldValue(item, null, false));
    } else if (name === "buildingId") {
      const clearFields = clearableFields("buildingId");
      clearFields.map((item) => setFieldValue(item, null, false));
    }
  };

  const turkishCharacterRegex = (keyword) =>
    keyword
      .replace(/[ıİiI]/g, "[ıİiI]")
      .replace(/[şŞsS]/g, "[şŞsS]")
      .replace(/[çÇcC]/g, "[çÇcC]")
      .replace(/[ğĞgG]/g, "[ğĞgG]")
      .replace(/[öÖoO]/g, "[öÖoO]")
      .replace(/[üÜuU]/g, "[üÜuU]");

  const customFilter = (option, searchText) =>
    turkishCharacterRegex(option.label)
      .toLowerCase()
      .includes(turkishCharacterRegex(searchText).toLowerCase());
  return (
    <div className={className ? className : ""}>
      <label htmlFor={name}>{label} </label>
      <Select
        value={
          isExists(field.value) && options.length > 0
            ? options.find((option) => option[optionValue] === field.value)
            : ""
        }
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            height: "50px",
            borderColor: meta.touched && meta.error ? "red" : "#f0f0f0",
          }),
        }}
        isDisabled={disabled}
        isMulti={isMulti}
        getOptionValue={(option) =>
          optionValue ? `${option[optionValue]}` : `${option["id"]}`
        }
        getOptionLabel={(option) =>
          optionName ? `${option[optionName]}` : `${option["name"]}`
        }
        onChange={(option) => handleChange(option)}
        options={options}
        filterOption={customFilter}
        {...props}
      />
      {meta && meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default AddressSelectInput;
